import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { SystemWaitPointPlanSetting } from './models/system-wait-point-plan-setting';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/waitPointPlan';

/**
 * [システム] 待機場所計画 のプロバイダー.
 */
@Injectable()
export class SystemWaitPointPlanServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * 需要データアップロード.
   *
   * @param file ファイル
   * @returns Observable<ApiResponse>
   */
  upload(file: Blob): Observable<ApiResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${BASE_URL}/upload`;
    return this.servicer.postFormData<ApiResponse>(url, formData);
  }

  /**
   * 設定情報を取得.
   * 
   * @returns Observable<SystemWaitPointPlanSetting>
   */
  getSetting(): Observable<GenericItem<SystemWaitPointPlanSetting>> {
    const url = `${BASE_URL}/setting`;
    return this.servicer.get<GenericItem<SystemWaitPointPlanSetting>>(url);
  }

  /**
   * 設定情報更新.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  updateSetting(data: SystemWaitPointPlanSetting): Observable<ApiResponse> {
    const url = `${BASE_URL}/setting`;
    return this.servicer.postApi<SystemWaitPointPlanSetting, ApiResponse>(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-wait-point-plan-service.ts